import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

import { HeaderComponent } from '../../../../shared/components/header/header.component';
import { FooterActionComponent } from '../../../../shared/components/footer-action/footer-action.component';
import { LoadingBoxComponent } from '../../../../shared/components/loading-box/loading-box.component';

import { AlertService, AlertType } from '../../../../shared/services/alert.service';
import { DevolucoesVendaService } from '../../../../shared/services/apis/vendas/devolucoes-venda.service';
import { DevolucoesVendaRequest } from '../../../../shared/services/requests/vendas/devolucoes-venda.request';
import { FuncionalidadeEnum } from '../../../../shared/enums/usuario/funcionalidade.enum';
import { ModuloEnum } from '../../../../shared/enums/usuario/modulo.enum';

@Component({
  selector: 'app-devolucoes-venda',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    HeaderComponent,
    FooterActionComponent,
    LoadingBoxComponent,
  ],
  templateUrl: './devolucoes-venda.component.html',
  styleUrls: ['./devolucoes-venda.component.css'],
})
export class DevolucoesVendaComponent implements OnInit {
  public moduloEnum = ModuloEnum.Configuracoes;
  public funcionalidadeEnum = FuncionalidadeEnum.Configuracoes_Vendas;
  public form: FormGroup;
  public isLoading = false;
  public isSaving = false;
  private idDevolucoesVenda: number = 0;

  constructor(
    private formBuilder: FormBuilder,
    private devolucoesVendaService: DevolucoesVendaService,
    private alertService: AlertService,
    private router: Router
  ) {
    this.form = this.formBuilder.group({
      lancarEstoqueAutomatico: [false],
    });
  }

  ngOnInit(): void {
    this.carregarDados();
  }

  private carregarDados(): void {
    this.isLoading = true;
    this.devolucoesVendaService.get().subscribe({
      next: response => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }
        if (response.devolucoesVenda) {
          this.idDevolucoesVenda = response.devolucoesVenda.idDevolucoesVenda;
          this.form.patchValue({
            lancarEstoqueAutomatico: response.devolucoesVenda.lancarEstoqueAutomatico,
          });
        }
      },
      error: () => {
        this.isLoading = false;
        this.alertService.show('Aviso', 'Falha na comunicação com o servidor.', AlertType.warning);
      },
    });
  }

  public salvar(): void {
    this.isSaving = true;
    const request: DevolucoesVendaRequest = this.form.getRawValue();
    this.devolucoesVendaService.update(this.idDevolucoesVenda, request).subscribe({
      next: response => {
        this.isSaving = false;
        if (response.isError) {
          this.alertService.show('Aviso', response.errorDescription, AlertType.warning);
          return;
        }
        this.alertService.show('Sucesso', 'Configurações salvas com sucesso!', AlertType.success);
        this.voltar();
      },
      error: error => {
        this.isSaving = false;
        this.alertService.show('Aviso', error || 'Falha na comunicação com o servidor.', AlertType.warning);
      },
    });
  }

  public voltar(): void {
    this.router.navigate(['/configuracoes/vendas']);
  }
}
